import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ProductTypeDetailsResponse, ProductTypesService } from '@src/app/shared/backend/clients';
import { ConfirmationService } from 'primeng/api';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { PermissionService } from '@src/app/shared/services/permission.service';
import { Actions } from '@src/app/shared/backend/auth/Action';
import { DialogReasonComponent } from '@src/app/shared/components/dialog-reason/dialog-reason.component';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-view-product-type',
    templateUrl: './view-product-type.component.html',
    styleUrl: './view-product-type.component.scss',
    host: {
        class: 'app-view-product-type'
    },
    providers: [ConfirmationService],
    standalone: false
})
export class ViewProductTypeComponent extends BaseViewComponent implements OnInit, OnDestroy {

  private readonly destroyedComponent$ = new Subject<void>();

  @ViewChild('dialog') dialog: DialogReasonComponent | undefined;

  delete: boolean = false;
  allowModifyProductType: boolean = false;
  productTypeId: number = 0;
  productType: ProductTypeDetailsResponse = {
    id: 0,
    name: '',
    code: ''
  };

  constructor(
    private permissionService: PermissionService,
    private router: Router,
    private route: ActivatedRoute,
    private productTypesService: ProductTypesService) {
    super();
  }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    this.route.params
      .pipe(takeUntil(this.destroyedComponent$))
      .subscribe(async (params) => {
        this.productTypeId = Number(params['productTypeId']);
        if (this.productTypeId > 0) {
          await this.get();
        }
      });

    this.delete = await this.permissionService.hasActionPermissions(Actions.delete);
    this.allowModifyProductType = await this.permissionService.hasActionPermissions(Actions.modify_producttypes);
  }

  override async get() {
    try {
      this.productType = await firstValueFrom(this.productTypesService.apiProductTypesDetailsIdGet(this.productTypeId));
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  }

  goToEditProductType() {
    this.router.navigate([`/product-types/${this.productTypeId}/edit`]);
  }

  async showDeleteDialog(): Promise<void> {
    const deleteCheckResponses = await firstValueFrom(this.productTypesService.apiProductTypesDeleteCheckBatchPost([this.productTypeId]));

    this.dialog?.show(deleteCheckResponses);
  }

  async deleteProductType(doDelete: boolean): Promise<void> {
    if (doDelete) {
      await firstValueFrom(this.productTypesService.apiProductTypesDeleteIdDelete(this.productTypeId));

      this.router.navigate([`/product-types`]);
    }
  }

  ngOnDestroy(): void {
    this.destroyedComponent$.next();
    this.destroyedComponent$.complete();
  }
}
